const friendlyHttpErrors = [400, 401, 403, 422];

export default function isFriendlyHttpError(error: any) {
    return (
        typeof error === 'object' &&
        error.statusCode &&
        friendlyHttpErrors.includes(error.statusCode)
    );
}
